import {ClientPlacementAppAzure} from 'clientplacementapp';
import {LoadingSpinner} from 'common';
import {GlobalErrorBoundary} from 'error';
import {ProviderApp} from 'providerapp';
import {AzureProviderApp} from 'providerapp';
import React, {Suspense} from 'react';
import {BrowserRouter, Route,} from 'react-router-dom';
import {NamedOAuth2Config, OktaInitSignIn, OktaSecurity} from 'security';
import {Info} from './actuator/Info';
import {
    AzureOauth2Environment
} from "./security/component/azure/AzureOauth2Environment";
import { ApplicationRootProvider, ApplicationRootUrl} from 'common/component/ApplicationRootContext';
import { AzureProviderUserManagementApp } from 'usermanagementapp/provider/AzureProviderUserManagementApp';

const BhpnUserManagementAppAzure = React.lazy(() => import("usermanagementapp/bhpn/azure"));

const ProviderUserManagementApp = React.lazy(() => import('usermanagementapp/provider'));
const DefaultPortalScope = 'openid profile email groups';

const PROVIDER_APP_CONFIG: NamedOAuth2Config = {
    name: 'provider',
    issuer: process.env.REACT_APP_PROVIDER_PORTAL_OKTA_ISSUER ?? '',
    clientId: process.env.REACT_APP_PROVIDER_PORTAL_CLIENT_ID ?? '',
    scopes: (process.env.REACT_APP_PROVIDER_PORTAL_SCOPES ?? DefaultPortalScope).split(' '),
    pkce: true,
};
const USER_MANAGEMENT_APP_CONFIG: NamedOAuth2Config = {
    name: 'eum',
    issuer: process.env.REACT_APP_EXTERNAL_UM_PORTAL_OKTA_ISSUER ?? '',
    clientId: process.env.REACT_APP_EXTERNAL_UM_PORTAL_CLIENT_ID ?? '',
    scopes: (process.env.REACT_APP_EXTERNAL_UM_PORTAL_SCOPES ?? DefaultPortalScope).split(' '),
    pkce: true,
};

export const TheXOLVSuperPortal = () => {
    return (
        <GlobalErrorBoundary>
            <BrowserRouter>
                <Route path={'/'.concat(ApplicationRootUrl.AZURE_INTERNAL_CP_PROVIDER_ROUTE_NAME)} children={
                    <ApplicationRootProvider rootUrl={ApplicationRootUrl.AZURE_INTERNAL_CP_PROVIDER_ROUTE_NAME}
                    authType='internal'
                    >
                        <AzureOauth2Environment
                            applicationType={'Client Placement'}
                            children={<AzureProviderApp/>}
                        />
                    </ApplicationRootProvider>
                }/>

                {/* Client Placement App */}
                <Route path={'/'.concat(ApplicationRootUrl.AZURE_INTERNAL_CP_ROUTE_NAME)} children={
                    <ApplicationRootProvider rootUrl={ApplicationRootUrl.AZURE_INTERNAL_CP_ROUTE_NAME} authType='internal'>
                        <AzureOauth2Environment
                            applicationType={'Client Placement'}
                            children={<ClientPlacementAppAzure/>}
                        />
                    </ApplicationRootProvider>
                }/>

                {/* Internal User Management App */}
                <Route path={'/'.concat(ApplicationRootUrl.AZURE_INTERNAL_UM_ROUTE_NAME)} children={
                    <ApplicationRootProvider rootUrl={ApplicationRootUrl.AZURE_INTERNAL_UM_ROUTE_NAME} authType='internal'>
                        <AzureOauth2Environment
                            applicationType={'User Management'}
                            children={
                                <Suspense fallback={<LoadingSpinner centerScreen/>}>
                                    <BhpnUserManagementAppAzure/>
                                </Suspense>
                            }
                        />
                    </ApplicationRootProvider>
                }/>


                {/* common shared routes */}
                <Route path='/actuator/info' exact component={Info}/>
                <Route path='/oauth2/init' exact
                       children={
                           <OktaInitSignIn configs={[
                               PROVIDER_APP_CONFIG,
                               USER_MANAGEMENT_APP_CONFIG,
                           ]}/>
                       }
                />


                {/*Provider App */}
                <OktaSecurity oauth2Config={PROVIDER_APP_CONFIG}>
                    <ApplicationRootProvider rootUrl={ApplicationRootUrl.EXTERNAL_PROVIDER_APP_ROOT_URL} authType='external'>
                        <Route path={`/${PROVIDER_APP_CONFIG.name}`}
                               children={<ProviderApp/>}
                        />
                    </ApplicationRootProvider>
                </OktaSecurity>


                {/*External User Management App */}
                <OktaSecurity oauth2Config={USER_MANAGEMENT_APP_CONFIG}>
                    <ApplicationRootProvider rootUrl={ApplicationRootUrl.EXTERNAL_EUM_APP_ROOT_URL} authType='external'>
                        <Route path={`/${USER_MANAGEMENT_APP_CONFIG.name}`}
                               children={
                                   <Suspense fallback={<LoadingSpinner centerScreen/>}>
                                       <ProviderUserManagementApp/>
                                   </Suspense>
                               }
                        />
                    </ApplicationRootProvider>
                </OktaSecurity>
                {/*Azure Provider App */}
                <Route path={'/'.concat(ApplicationRootUrl.AZURE_INTERNAL_UM_PROVIDER_ROUTE_NAME)} children={
                    <ApplicationRootProvider rootUrl={ApplicationRootUrl.AZURE_INTERNAL_UM_PROVIDER_ROUTE_NAME} authType='internal'>
                        <AzureOauth2Environment
                            applicationType={'User Management'}
                            children={<AzureProviderUserManagementApp/>}
                        />
                    </ApplicationRootProvider>
                }/>
            </BrowserRouter>
        </GlobalErrorBoundary>
    );
}
